import styled from 'styled-components'

export const ContainerImg = styled.div`
  display: flex;
  padding: 1rem;
  border-radius: 50%;
  background: var(--gray100);
`
